// src/admin/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ user, requiredRole, children }) {
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    return <p style={{ color: "red" }}>Anda tidak memiliki akses ke halaman ini.</p>;
  }

  return children;
}
